// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"490":"31d967b6fb66de33","1912":"2e868cbd9dfc3093","4553":"46c6198b806c8497","8422":"815a3b48b82ca1d1","8537":"7e5c6ae61ed9bc74"}[chunkId] + ".js";
};